import DigitSymbolShape from './DigitSymbolShape.vue';
export default {
  name: 'MappingLegend',
  components: {
    DigitSymbolShape
  },
  props: {
    mapping: {
      type: Array,
      default: () => []
    },
    compact: {
      type: Boolean,
      default: false
    }
  }
};